import styled from "styled-components";

export const FollowStyled = styled.div`
	padding: 1rem 1.2rem;
	width: 400px;

	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	row-gap: 2rem;

	.follow-container {
		width: 100%;
		background-color: var(--color-brand-5-transparent);
		border-radius: var(--radius);

		#follow {
			height: 300px;
			max-height: 400px;
			padding: 1rem 2rem;
			display: flex;
			flex-direction: column;
			row-gap: 2rem;

			overflow-y: scroll;

			.item {
				display: flex;
				align-items: center;
				column-gap: 1rem;

				img {
					width: 50px;
					height: 50px;
					border-radius: 50%;
					background-color: var(--color-white-fixed);
				}

				button {
					margin: 0 0 0 auto;
				}
			}
		}
	}
`;
